import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import {choose} from 'lit/directives/choose.js';
import {when} from 'lit/directives/when.js';
import {AttributeInterpreter, ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import store from '../../store';
import {selectProductData, selectSpcConfiguration, selectSpcConfigurations} from '../../selectors';
import {getProductData} from '../../util/getProductData';

// renders the appropriate attribute component based on configuration and data
@customElement('spc-attribute')
export class SpcAttribute extends connect(store)(LitElement) {

	@property({type: Object})
	attributeId = {};

	@property({type: Boolean})
	hideDisabledValues = false

	@property({type: String})
	displayStyle = null;

	@property({type: String})
	instance = 'default';

	@property({type: Array})
	excludedValues = [];

	@property({type: Object})
	addon = null;

	constructor() {
		super();
		this.type = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		const isDefaultInstance = this.instance === 'default' || this.instance === undefined || this.instance === null;
		const configuration = isDefaultInstance ? selectSpcConfiguration(state) : selectSpcConfigurations(state)[this.instance];
		// console.log(this.instance, configuration, selectSpcConfigurations(state));
		if (configuration) {
			const attribute = ConfigurationInterpreter.getChoiceAttribute(configuration, this.attributeId);
			if (attribute) {
				this.type = attribute.type;
			} else {
				this.type = 'Choice';
			}
			this.attributeProductData = getProductData(this.attributeId.localId, selectProductData(state));
		}
		if (!this.displayStyle) {
			this.displayStyle = this.attributeProductData?.displayStyle ?? 'compactSelect';
		}
		if (configuration && this.type === 'Choice') {
			const attribute = ConfigurationInterpreter.getChoiceAttribute(configuration, this.attributeId);
			const values = AttributeInterpreter.getAllowedChoiceValues(attribute);
			if (values && values.length > 40) this.displayStyle = 'comboSelect';
		}
	}

	render() {
		return html`
			${choose(
				this.type,
				[
					['Choice', () =>
						html`${choose(this.displayStyle,
							[
								['colorSelect',
									() => html`
										<spc-choice-attribute-color instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
																	.hideDisabledValues=${this.hideDisabledValues}
																	.excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['comboSelect',
									() => html`
										<spc-choice-attribute-combo instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
																	.hideDisabledValues=${this.hideDisabledValues}
																	.excludedValues=${this.excludedValues}></spc-choice-attribute-combo>`
								],
								['listSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
															  .hideDisabledValues=${this.hideDisabledValues}
															  .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['reducedSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
															  .hideDisabledValues=${true} .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['compactSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
															  .hideDisabledValues=${this.hideDisabledValues}
															  .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								() => html`
									<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
														  .hideDisabledValues=${this.hideDisabledValues} .excludedValues=${this.excludedValues}></spc-choice-attribute>`
							])}`
					],
					['Component', () =>
						html`
							<spc-component-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
													 .hideDisabledValues=${this.hideDisabledValues}></spc-component-attribute>`
					],
					['Boolean', () =>
						html`
							<spc-boolean-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
												   .hideDisabledValues=${this.hideDisabledValues}></spc-boolean-attribute>`
					],
					['Numeric', () =>
						html`
							<spc-numeric-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attributeId=${this.attributeId}
												   .hideDisabledValues=${this.hideDisabledValues}></spc-numeric-attribute>`
					],
					() => html`<span>Unknown Type ${this.type} (${this.attributeId.localId})</span>`
				]
			)}
			${when(this.addon !== null, () => this.addon)}
		`;
	}
}
